import { Box, Image } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';
import { CloseIcon } from 'Asset/icon';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const StoreBadge = ({ store, onClose }) => {
  const containerHeight = onClose ? '28px' : '22px';
  return (
    <Box className={styles['store-badge__container']} backgroundColor={store?.ecommerce?.color} height={containerHeight} data-testid="store-badge">
      <Box className={styles['store-badge__image']}>
        <Image src={store?.ecommerce?.logo} alt={store?.name} width={onClose ? '14px' : '10px'} height={onClose ? '14px' : '10px'} objectFit="contain" />
      </Box>
      <TextRegular fontSize={onClose ? '14px' : '10px'} color="#1A1A1A">
        {store?.name}
      </TextRegular>
      <Condition statement={onClose}>
        <CloseIcon onClick={onClose} />
      </Condition>
    </Box>
  );
};

export default StoreBadge;
